module.exports = __webpack_public_path__ + "img/businesshours.73652f33.png";